import _get from "lodash/get";
import _isNil from "lodash/isNil";
import _sortBy from "lodash/sortBy";
import _first from "lodash/first";
import _map from "lodash/map";
import expressions from './expressions';
import { isItemsCorrect } from './solution';
export default (sct, items, itemsSolution) => {
  const checkResults = _map(sct.checks, check => {
    const {
      item,
      result
    } = expressions(check.condition, items, itemsSolution);
    return {
      item,
      message: result !== check.shouldBe ? check.message : undefined
    };
  });
  const checkResult = _first(_sortBy(checkResults.filter(_ref => {
    let {
      message
    } = _ref;
    return !_isNil(message);
  }),
  // LastMove has a higher priority
  _ref2 => {
    let {
      item
    } = _ref2;
    return _get(item, 'lastMove') ? 0 : 1;
  }));
  if (isItemsCorrect(items, itemsSolution, sct.isOrdered)) {
    if (!_isNil(checkResult)) {
      throw new Error("The submission matches the solution but one of the checks has feedback: (".concat(checkResult.message, ")"));
    }
    return {
      feedbackMessage: null,
      isCorrect: true
    };
  }
  return {
    feedbackMessage: _get(checkResult, 'message'),
    isCorrect: false,
    item: _get(checkResult, 'item')
  };
};